



















































import { Vue, Component } from 'vue-property-decorator';
import { Account, PasswordInfo } from '@/modules/me';
import { ElForm } from 'element-ui/types/form';

@Component
export default class MyPage extends Vue {
  private formData: PasswordInfo = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };

  private formRule = {
    oldPassword: [
      { required: true, message: '現在のパスワードを入力してください' },
    ],
    newPassword: [
      { required: true, message: '新しいパスワードを入力してください' },
      { validator: this.validateNewPassword, trigger: 'blur' },
      {
        pattern: '^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,}$',
        trigger: 'blur',
        message: '６桁以上の英数字を入力してください',
      },
    ],
    confirmPassword: [
      { required: true, message: 'パスワード(確認)を入力してください' },
      { validator: this.validateConfirmPassword, trigger: 'blur' },
    ],
  };

  private validateNewPassword(rule: any, value: string, callback: any) {
    if (value === this.formData.oldPassword) {
      callback(new Error('同じパスワードは使用できません'));
    } else {
      callback();
    }
  }

  private validateConfirmPassword(rule: any, value: string, callback: any) {
    if (value === this.formData.newPassword) {
      callback();
    } else {
      callback(new Error('パスワードが異なります'));
    }
  }

  get loading(): boolean {
    return this.$store.state.me.loading;
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get userName(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName}　${this.user.firstName}`;
    }
  }

  get pageTitle(): string {
    return `
      <div>
        <span style="font-size:x-large; font-weight:bold;">${this.userName}</span>
        <span style="font-size:medium; margin-left:10px;">さんの情報</span>
      </div>`;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('me/fetchMyData');
  }

  private async onSubmit() {
    (this.$refs.form as ElForm).validate(async (valid) => {
      if (!valid) {
        return false;
      } else {
        try {
          await this.$store.dispatch('me/changePassword', { id: this.user.id, passwordInfo: this.formData });
          this.$notify({
            title: 'パスワード変更完了',
            message: `パスワードを変更しました。`,
            position: 'bottom-right',
            type: 'success'
          });
          this.$router.push({ name: 'Top' });
        } catch (error) {
          this.$notify.error({
            title: 'パスワード変更エラー',
            message: error.message,
            position: 'bottom-right'
          });
        }
      }
    });
  }

  private onCancel() {
    this.$router.push({ name: 'Top' });
  }
}
